export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-home-1efa4bb7249d4a99d150ca88d75528c0.svg";